import React from 'react';
import { cn } from '@/utils/cn';
import { Button } from '@/components/UI/Button';

export interface PaginationProps {
  /** Zero-based current page. */
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  previousLabel?: string;
  nextLabel?: string;
  className?: string;
}

/** Previous / "2 / 5" / Next. Renders nothing when there is only one page. */
export const Pagination: React.FC<PaginationProps> = ({
  page, totalPages, onPageChange, previousLabel = 'Previous', nextLabel = 'Next', className,
}) => {
  if (totalPages <= 1) return null;
  return (
    <nav aria-label="Pagination" className={cn('flex items-center justify-center gap-2 pt-2', className)}>
      <Button variant="outline" size="sm" disabled={page <= 0} onClick={() => onPageChange(page - 1)}>
        {previousLabel}
      </Button>
      <span className="text-sm text-ui-text2" aria-live="polite">{page + 1} / {totalPages}</span>
      <Button variant="outline" size="sm" disabled={page >= totalPages - 1} onClick={() => onPageChange(page + 1)}>
        {nextLabel}
      </Button>
    </nav>
  );
};

export default Pagination;
